module.exports = __webpack_public_path__ + "static/media/digitiz.5024b797.webp";